import api from '@/services/api/config';
import typ from './typ';

const path = 'v1/dokument';

export default {
  typ,
  delete: (id) => api.delete(`${path}/${id}`),
};
